import { useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { setUser, setLoggedIn } = useAuth();
  const [name, setName] = useState(localStorage.getItem("name") || "");
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        "https://callcenter.teech.tv/api/auth/login",
        {
          username: name,
          password: password,
        },
      );

      if (response) {
        const { success, data } = response.data;
        if (success) {
          setLoggedIn(true);
          setUser(data);
          // Save user to localStorage for Firebase error tracking
          localStorage.setItem("user", JSON.stringify(data));
        } else {
          setAuthError("Internal Server Error! Please try it later");
        }
      }
    } catch (error) {
      if (error?.message) {
        setAuthError(error.message);
      } else if (error?.response?.data?.message) {
        setAuthError(error.response.data.message);
      } else {
        setAuthError("Internal Server Error! Please try it later");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      {loading && (
        <div className="loading">
          <span className="loader"></span>
        </div>
      )}
      {authError && <div className="login__error">{authError}</div>}
      <form className="login__form" onSubmit={submit}>
        <div className="login__form__row">
          <label htmlFor="email" className="login__form__label">
            Your name
          </label>
          <input
            className="login__form__input"
            placeholder="Enter your name"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="login__form__row">
          <label htmlFor="email" className="login__form__label">
            Your name
          </label>
          <input
            className="login__form__input"
            placeholder="Enter your password"
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="login__form__submit" disabled={!name}>
          Submit
        </button>
      </form>
    </div>
  );
};

export default Login;
